import React from 'react';
import { ProductItemResponse } from '@/api/product/types';
import { Image, Price } from '@/components/shared';
import { breakpoints } from '@/types/breakpoints';
import styles from './ProductLine.module.scss';

export const ProductLine: React.FunctionComponent<ProductItemResponse> = ({ name, brand, image }) => {
	return (
		<div className={styles.wrapper}>
			<div className={styles.imageWrapper}>
				<Image
					className={styles.image}
					size180={image.size180}
					size320={image.size320}
					size480={image.size480}
					// Has to match --thumbSize
					responsiveSizesSettings={`(min-width: ${breakpoints.md}px) 100px, 70px`}
					altText={image.altText || name}
				/>
			</div>

			<div className={styles.content}>
				{brand && <div className={styles.brand}>{brand}</div>}
				<p className={styles.name}>{name}</p>
				<Price />
			</div>
		</div>
	);
};
